// src/axiosConfig.js
import axios from 'axios';

/**
 * Dynamically compute the baseURL at runtime based on window.location.
 * This way, you can run the same compiled build in Codespaces port 80 or 8000,
 * or locally in production mode (localhost:80), without needing separate builds.
 */
function getBaseURL() {
  const { protocol, hostname, port } = window.location;

  // If running in GitHub Codespaces:
  //   e.g., mycodespace-80.app.github.dev or mycodespace-8000.app.github.dev
  // We'll just use whatever the browser sees in window.location, because
  // the protocol, hostname, and port should reflect the actual environment.
  //
  // In case you want more specific logic:
  // - Check if hostname ends with '.app.github.dev'
  // - Check if port === '80' or port === '8000'
  // but for many cases, simply using protocol://hostname[:port] is enough.

  // Special case for "localhost" if you always want port 80:
  if (hostname === 'localhost') {
    return 'http://localhost:80';
  }

  // Default fallback: reconstruct the current URL (protocol + hostname + port if present)
  // e.g. https://mycodespace-80.app.github.dev
  // or https://mycodespace-8000.app.github.dev:8000 (if port is actually set)
  let base = `${protocol}//${hostname}`;
  if (port && port !== '80' && port !== '443') {
    base += `:${port}`;
  }
  return base;
}

const baseURL = getBaseURL();
console.log('[axiosConfig] Detected baseURL:', baseURL);

const axiosInstance = axios.create({
  baseURL,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

// Add a request interceptor to include the Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('_auth');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// (Optional) Add a response interceptor to handle token refresh, etc.

export default axiosInstance;
